import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const Stripe = ({ children, second = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const idMediumWidth = useMediaQuery(
    `(min-width:${theme.breakpoints.values.sm}px) and (max-width:${theme.breakpoints.values.lg}px)`
  );
  const isBetween800and1000 = useMediaQuery('(min-width:800px) and (max-width:1000px)');
  const { i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';

  const getTop = () => {
    if (!second) return 5;
    if (isBetween800and1000) return 205;
    if (isMobile) return 80;
    if (idMediumWidth) return 110;
    return 110;
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: getTop(),
        left: isArabic ? 'auto' : isMobile ? "0.8em" : "5em",
        right: isArabic ? (isMobile ? "0.8em" : "5em") : 'auto',
        width: second ? "auto" : idMediumWidth ? "85%" : "90%",
        maxWidth: second ? (idMediumWidth ? "50%" : isMobile ? "85%" : "25%") : "90%",
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        py: 0.7,
        px: 2,
        borderRadius: "15px",
        backgroundColor: "rgba(255, 255, 255, 0.75)",
        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
        zIndex: 100,
      }}
    >
      {children}
    </Box>
  );
};

export default Stripe;
